import { Box, Typography, styled } from '@mui/material';

export const StyledImportRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2)
}));

export const StyledFileNameText = styled(Typography)({
  fontStyle: 'italic'
});

export const StyledFindingsBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  height: 300
}));

export const StyledHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1
});
